import { render } from "./Card.vue?vue&type=template&id=050253b5&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=050253b5&lang=scss&scoped=true"

import exportComponent from "D:\\dev\\vuejs\\nafn\\nafn.urmull.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050253b5"]])

export default __exports__